import { ContainerComponent, wrap, today } from 'AppReact';
import Controller from './controller';
import {
  RoundedFilterHeaderWrapper, WhiteSpaceNoWrap, Mr3,
  FitRelativeWrapper, AbsoluteLeftTopWrapper, Mt3,
  CustomBorderWrapper, FlexBoxWrapper,
  CustomHeight, NotPaddedGrowWrapper, Mx4, Mt4, Px3,
  ColumnBetweenWrapper, Mb4, BorderLeftWrapper, Mb2,
  BorderBottomWrapper, MediaListScrollWrapper, Mt10,
  Width350, Mr2
} from 'wrappers';
import internalState from './internalState';
import { SecondaryTextSm, Icon } from 'atoms';
import { DownCaretSvg, RefreshArrowSvg } from 'components/icons';
import { IconTextButton, TabButton } from 'molecules';
import CalendarMonth from '../calendarMonth';
import { SearchTermButton } from 'molecules';
import CustomCalendarHeaderInputs from '../customCalendarHeaderInputs';
import DatePickerButtons from '../datePickerButtons';
import { getSelectedTimeSpanName, getSelectedTimeSpanByDate } from 'utils';

export const definition = {
  name: 'DateRangePicker',
  controller: Controller,
  initialProps: ({ startDate, endDate, isReadonly, label, displayExactDates }) => ({
    selectedTimeSpan: getSelectedTimeSpanByDate({ startDate, endDate }),
    startDate, endDate, isReadonly, label, displayExactDates,
    selectedYear: endDate?.getFullYear() ?? today().getFullYear()
  }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: RoundedFilterHeaderWrapper,
          name: 'Header',
          isButton: true,
          renderIf: ({ selectedTimeSpan, isOpen }) => (isOpen && selectedTimeSpan !== 'custom') || !isOpen,
          displayState: ({ isReadonly, startDate, endDate, isOpen }) => ({ disabled: isReadonly, completed: startDate && endDate && !isOpen }),
          bindings: ({ isOpen, isReadonly, startDate, endDate, selectedTimeSpan, selectedYear, containerRef, yearListRef, monthListRef }) => ({ yearListRef, isOpen, containerRef, isReadonly, startDate, endDate, selectedTimeSpan, selectedYear, monthListRef }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextSm, WhiteSpaceNoWrap), Mr3),
              displayValue: ({ label, startDate, endDate }) => label ? label : startDate && endDate ? 'Date' : 'Filter by date',
            },
            {
              component: wrap(SearchTermButton, Mr2),
              name: 'SearchTerm',
              renderIf: ({ selectedTimeSpan, startDate, endDate }) => (selectedTimeSpan && selectedTimeSpan !== 'custom') || (startDate && endDate),
              bindings: ({ selectedTimeSpan, startDate, endDate, displayExactDates }) => ({ text: getSelectedTimeSpanName({ startDate, endDate, selectedTimeSpan, displayExactDates }) })
            },
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ isOpen }) => DownCaretSvg({ up: isOpen, color: '#C2CCCE' })
            },
          ]
        },
        {
          component: CustomCalendarHeaderInputs,
          renderIf: ({ selectedTimeSpan, isOpen }) => selectedTimeSpan === 'custom' && isOpen,
          name: 'CustomHeader',
          bindings: ({ startDate, endDate, isReadonly, editingDate }) => ({ startDate, endDate, isReadonly, editingDate })
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '50px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
              elements: [
                {
                  wrapper: FlexBoxWrapper,
                  name: 'CalendarWrapper',
                  elements: [
                    {
                      wrapper: ColumnBetweenWrapper,
                      name: 'LeftSideWrapper',
                      elements: [
                        {
                          component: wrap(DatePickerButtons, Mt3),
                          name: 'Buttons',
                          bindings: ({ startDate, endDate, selectedTimeSpan }) => ({ startDate, endDate, selectedTimeSpan })
                        },
                        {
                          component: wrap(wrap(wrap(IconTextButton, FlexBoxWrapper), Mx4), Mb4),
                          name: 'Reset',
                          bindings: ({ }) => ({ icon: RefreshArrowSvg({}), title: 'Refresh' })
                        },
                      ]
                    },
                    {
                      wrapper: BorderLeftWrapper,
                      name: 'RightSideWrapper',
                      elements: [
                        {
                          wrapper: CustomHeight,
                          name: 'ListWrapper',
                          displayState: ({ }) => ({ height: 566, display: 'flex', flexDirection: 'column' }),
                          elements: [
                            {
                              wrapper: wrap(wrap(wrap(MediaListScrollWrapper, Width350), BorderBottomWrapper), Mx4),
                              name: 'YearList',
                              ref: ({ yearListRef }) => yearListRef,
                              elements: [
                                {
                                  component: wrap(wrap(TabButton, Mb2), Mt4),
                                  isListOf: { year: ({ }) => Array.from(Array(60).keys()) },
                                  name: 'Year',
                                  bindings: ({ year, startDate, endDate, monthListRef }) => ({ title: (year + 2000).toString(), year: year + 2000, startDate, endDate, monthListRef }),
                                  displayState: ({ selectedYear, year }) => ({ fontSize: 12, selected: selectedYear === (year + 2000) })
                                },
                              ]
                            },
                            {
                              wrapper: NotPaddedGrowWrapper,
                              name: 'ListWrapper',
                              ref: ({ monthListRef }) => monthListRef,
                              elements: [
                                {
                                  component: wrap(wrap(CalendarMonth, Mt10), Px3),
                                  isListOf: { month: ({ }) => Array.from(Array(12).keys()) },
                                  name: 'Month',
                                  bindings: ({ month, selectedYear, startDate, endDate, selectedTimeSpan, editingDate }) => {
                                    return {
                                      year: selectedYear,
                                      month,
                                      selectedDates: [startDate, endDate],
                                      selectedPeriod: [startDate, endDate],
                                      startDate, endDate, selectedTimeSpan, editingDate
                                    }
                                  }
                                }
                              ]
                            },
                          ]
                        },
                      ]
                    }
                  ]
                }

              ]
            }
          ]
        }

      ]
    }
  ]
};

export default ContainerComponent(definition)